import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _keys from 'lodash/keys';
import _map from 'lodash/map';
var REGEX_SPECIALS = '+*'; //list of characters that need to be escaped for RegExp use

/**
 * HTML entities to unescape
 */

var UNESCAPE_HTML = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': '\'',
  '&#x2F;': '/',
  '&#34;': '"',
  '&#64;': '@',
  '&#96;': '`',
  '&#43;': '+',
  '&#61;': '='
};
var unescapeHtmlRegExp = new RegExp(_keys(UNESCAPE_HTML).join('|'), 'g');
/**
 * HTML entities to escape
 */

var ESCAPE_HTML = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '\'': '&#39;',
  '/': '&#x2F;',
  '"': '&#34;',
  '@': '&#64;',
  '`': '&#96;',
  '+': '&#43;',
  '=': '&#61;'
}; //Gets the list of keys that need to be matched by RegExp.
//It also checks if any of the keys is a special RegExp character that needs to be escaped

var escapeHTMLKeys = _map(_keys(ESCAPE_HTML), function (k) {
  return _indexOfInstanceProperty(REGEX_SPECIALS).call(REGEX_SPECIALS, k) > -1 ? "\\" + k : k;
});

var escapeHtmlRegExp = new RegExp(escapeHTMLKeys.join('|'), 'g');
/**
 * Unescapes HTML entities in the given string
 * @param {string} str - the HTML string to be unescaped
 * @returns {string} the unescaped string
 */

var unescapeHTML = function unescapeHTML(str) {
  return str.replace(unescapeHtmlRegExp, function (entity) {
    return UNESCAPE_HTML[entity] || entity;
  });
};
/**
 * Escapes HTML entities in the given string
 * @param {string} str - the HTML string to be escaped
 * @returns {string} the escaped string
 */


var escapeHTML = function escapeHTML(str) {
  return str.replace(escapeHtmlRegExp, function (entity) {
    return ESCAPE_HTML[entity] || entity;
  });
};

export default {
  escapeHTML: escapeHTML,
  unescapeHTML: unescapeHTML
};
//# sourceMappingURL=html.js.map